import {
  ChangeDetectionStrategy,
  Component,
  HostListener,
  Inject,
  ViewEncapsulation,
} from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@sc/ui-components';
import { SnackBarData } from '../../types';

@Component({
  selector: 'sc-snackbar',
  styleUrls: ['./snackbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, TranslateModule],
  template: `
    <div
      class="container"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby="sc-bottom-snackbar-title"
      aria-describedby="sc-bottom-snackbar-body"
    >
      <p>
        <span
          id="sc-bottom-snackbar-title"
          role="heading"
          aria-level="1"
          class="hide-focus-outline"
          tabindex="-1"
          >{{ data.emoticon }} {{ data.title }}</span
        >
        <span id="sc-bottom-snackbar-body" class="msg">{{ data.message }}</span>
      </p>

      <button type="button" (click)="onCloseClick()">
        <span class="sr_only">{{
          'GlobalApplicativeConstants.accessibility.closeSnackbar' | translate
        }}</span>
        <sc-icon name="close"></sc-icon>
      </button>
    </div>
  `,
})
export class SnackbarComponent {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: SnackBarData) {}

  @HostListener('document:keydown.escape')
  onCloseClick(): void {
    this.data.currentSnackBar.dismiss();
  }
}
